import { SVGProps } from 'react';

const BrainCog = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m10.852 14.772-.383.923m.383-6.467-.383-.923m2.68 6.467.381.924m.001-7.391-.383.923m1.624 1.624.923-.383m-.923 2.679.923.383M6.402 6.5A3 3 0 1 1 12 5a3 3 0 1 1 5.598 1.5M6.002 5.125a4 4 0 0 0-2.525 5.771m14.521-5.771a4 4 0 0 1 2.525 5.771m-1.018-.602a4 4 0 0 1-1.5 7.706m-13.973-.517A4 4 0 0 0 11.464 20c.18-.311.892-.311 1.072 0a4 4 0 0 0 7.432-2.516M4.5 10.29A4 4 0 0 0 6 18m3.228-7.148-.923-.383m.923 2.679-.923.383M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default BrainCog;
